import { ChangeDetectionStrategy, Component, inject, Input, OnChanges } from '@angular/core';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { RatingComponent } from '@df/ui/common/rating.component';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { UiComponent } from '@df/ui/ui.component';
import { productReviewsModalId } from '../cms/product-reviews-modal/product-reviews-modal.component';

@Component({
    selector: 'product-reviews-summary',
    templateUrl: 'product-reviews-summary.html',
    standalone: true,
    imports: [RatingComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductReviewsSummaryComponent extends UiComponent implements OnChanges {
    /**
     * Source product
     */
    @Input({
        required: true
    })
    source!: Product<IProductDataV3>;
    private dfModalService = inject(DfModalService);
    /**
     * Retrieves reviews qty
     */
    getQty(): number {
        return this.source?.data?.reviews?.count || 0;
    }
    /**
     * Retrieves reviews aggregated rating
     */
    getRating(): number {
        return parseFloat(((this.source?.data?.reviews?.rating || 0) / 20).toFixed(1));
    }
    showStoreModal() {
        this.dfModalService.open(undefined, productReviewsModalId, undefined, {
            product: this.source,
            rating: this.getRating(),
            count: this.getQty()
        });
    }
}
